module.exports = __webpack_public_path__ + "static/media/Files.36223eea.png";